import { Suspense, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  OrbitControls,
  Bounds,
  ContactShadows,
  useGLTF,
} from "@react-three/drei";
import * as THREE from "three";
import Typist from "react-typist";
import { ReactComponent as SapLogo } from "./sap-logo.svg";
import { Button } from "@mantine/core";

export default function App() {
  return (
    <>
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          pointerEvents: "none",
        }}
      >
        <Canvas
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            pointerEvents: "auto",
            top: "-25%",
            right: "-25%",
          }}
          camera={{ position: [0, 0, 200], fov: 50 }}
          dpr={[1, 2]}
        >
          {/* <OrbitControls enableZoom={false} /> */}
          <spotLight
            position={[-100, -100, -100]}
            intensity={0.2}
            angle={0.3}
            penumbra={1}
          />
          <hemisphereLight
            color="white"
            groundColor="gray"
            position={[-7, 25, 13]}
            intensity={1}
          />
          <Suspense fallback={null}>
            <Bounds fit clip margin={1.2}>
              <Model name="DNA" position={[7, -15, 28]} rotation={[1, 0, -2]} />
              <Model
                name="Headphones"
                position={[20, 2, 4]}
                rotation={[1, 0, -1]}
                scale={0}
              />
              <Model
                name="Notebook"
                position={[-21, -15, -13]}
                rotation={[2, 0, 1]}
              />
              <Model
                name="Rocket003"
                position={[18, 15, -25]}
                rotation={[1, 1, 0]}
                scale={0}
              />
              <Model
                name="VR_Headset"
                position={[-10, 15, -25]}
                rotation={[1, 0, -1]}
                scale={0}
              />
            </Bounds>
            <ContactShadows
              rotation-x={Math.PI / 2}
              position={[0, -35, 0]}
              opacity={0.2}
              width={200}
              height={200}
              blur={1}
              far={50}
            />
          </Suspense>
          <Rig />
        </Canvas>
        <div
          style={{
            color: "white",
            fontFamily: "Short Stack, cursive",
            minHeight: "100vh",
            textShadow: "1px 1px black",
          }}
        >
          <div className="padded" style={{ minHeight: "100vh" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative",
              }}
            >
              <div className="pjsdc-header">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src="./pjsdc.jpeg" alt="logo" />
                </div>
                <br />
                <div className="text">PJSDC</div>
              </div>
              <div style={{ margin: "1rem", fontSize: "32px" }}>X</div>
              <SapLogo className="sap-logo" />
            </div>
            <div
              className="title"
              style={{
                marginTop: "2rem",
                textShadow: "0px 3px black",
              }}
            >
              <Typist avgTypingDelay={20} cursor={{ hideWhenDone: true }}>
                <Typist.Delay ms={2500} />
                <span role="img" aria-label="title">
                  ✨ Beginner's Coding Bootcamp
                  <br />
                  March 2022
                  <br />
                  <span style={{ fontSize: "2rem", lineHeight: "2rem" }}>
                    👨🏻‍💻🥾🏕
                  </span>
                </span>
              </Typist>
            </div>
            <div
              style={{
                display: "flex",
                marginTop: "4rem",
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  flex: "1 0 360px",
                  pointerEvents: "auto",
                  zIndex: "2",
                }}
              >
                <div
                  role="img"
                  aria-label="text"
                  style={{
                    fontSize: "14px",
                    fontFamily: "Short Stack, cursive",
                  }}
                >
                  <div className="sticky">
                    <Button
                      style={{ marginBottom: "1rem" }}
                      variant="gradient"
                      gradient={{ from: "grape", to: "pink", deg: 35 }}
                      onClick={() => {
                        window.location.href =
                          "https://forms.gle/zy1EB4uy2oCnj2GV7";
                      }}
                    >
                      Register Here! 👈
                    </Button>
                  </div>
                  <div>Lesson Plan:</div>
                  <ol>
                    <li>Intro to HTML</li>
                    <li>Intro to CSS</li>
                    <li>Images and Backgrounds</li>
                    <li>Layouts I</li>
                    <li>Layouts II</li>
                    <li>Interactive Styling</li>
                    <li>Animations</li>
                    <li>Responsive Design</li>
                    <li>Build your own blog!</li>
                  </ol>
                  {/* <p>We'll be segregating students according to age:</p> */}
                  {/* <ul> */}
                  {/*   <li>Ages 9-12</li> */}
                  {/*   <li>Ages 13-15</li> */}
                  {/*   <li>Ages 16 and above</li> */}
                  {/* </ul> */}
                  {/* <p> */}
                  {/*   By the time you complete this course you should have the */}
                  {/*   fundamentals to land a job as a junior front-end developer */}
                  {/*   💪. */}
                  {/* </p> */}
                  <div>
                    One FREE trial class! 😊
                    <ul>
                      <li>07 Mar 2022 MON @ 8pm-8:30pm</li>
                    </ul>
                  </div>
                  <div>Teachers:</div>
                  <ul>
                    <li>
                      <div>George Yong</div>
                      <ul>
                        <li>8 years of programming experience</li>
                        <li>
                          Industries: Hospitality, human resource, retail,
                          golfing, construction, property, entertainment,
                          telecommunications
                        </li>
                        <li>IFCA, Astro, Digi</li>
                      </ul>
                    </li>
                    <li>
                      <div>Tapan Sabat</div>
                      <ul>
                        <li>BEng Information Technology</li>
                        <li>12 years of programming experience</li>
                        <li>Industries: Finance, e-commerce, healthcare</li>
                        <li>Naaptol, BNP Paribas, SWIFT, MoH Malaysia</li>
                      </ul>
                    </li>
                    <li>
                      <div>Jonathan Andrew Fernandez</div>
                      <ul>
                        <li>5 years of programming experience</li>
                        <li>Industries: Construction, Golfing</li>
                        <li>IFCA, Pulsifi</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontFamily: "Short Stack, cursive",
                  }}
                >
                  <p>Class Options:</p>
                  <ul>
                    <li>
                      🌞 Mornings Bootcamp
                      <ul>
                        <li>09 Mar 2022 WED @ 9am-12pm</li>
                        <li>10 Mar 2022 THU @ 9am-12pm</li>
                        <li>11 Mar 2022 FRI @ 9am-12pm</li>
                      </ul>
                    </li>
                    <li>
                      🌤 Afternoons Bootcamp
                      <ul>
                        <li>09 Mar 2022 WED @ 2pm-5pm</li>
                        <li>10 Mar 2022 THU @ 2pm-5pm</li>
                        <li>11 Mar 2022 FRI @ 2pm-5pm</li>
                      </ul>
                    </li>
                    <li>
                      🌛 Evenings Bootcamp
                      <ul>
                        <li>09 Mar 2022 WED @ 6:30pm-9:30pm</li>
                        <li>10 Mar 2022 THU @ 6:30pm-9:30pm</li>
                        <li>11 Mar 2022 FRI @ 6:30pm-9:30pm</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <p
                  role="img"
                  aria-label="text"
                  style={{
                    fontSize: "14px",
                    fontFamily: "Short Stack, cursive",
                  }}
                >
                  Cost per student 👨🏻‍💻 will be RM450 (for 9 hours)
                </p>
                <p
                  role="img"
                  aria-label="text"
                  style={{
                    fontSize: "14px",
                    fontFamily: "Short Stack, cursive",
                  }}
                ></p>
                <div
                  role="img"
                  aria-label="text"
                  style={{
                    fontSize: "14px",
                    fontFamily: "Short Stack, cursive",
                  }}
                >
                  <p>We have ⭐ Intermediate and 🌟 Advanced classes too!</p>
                  <p>
                    You may contact us via phone or WhatsApp 📞:
                    <br />
                    PJSDC Maryanne +6016-5887926{" "}
                  </p>
                  <p>
                    And also via email 📨: <br />
                    pjspeechanddrama@gmail.com
                  </p>
                </div>
              </div>
              <div
                className="r3f"
                style={{ pointerEvents: "auto", zIndex: "0" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Rig({ v = new THREE.Vector3() }) {
  return useFrame((state) => {
    state.camera.position.lerp(
      v.set(state.mouse.x * 10, state.mouse.y * 10, 550),
      0.05
    );
  });
}

function Model({ name, ...props }) {
  const { nodes } = useGLTF("/compressed.glb");
  const ref = useRef();

  useFrame(() => {
    ref.current.rotation.x += 0.01;
  });

  return (
    <mesh
      ref={ref}
      geometry={nodes[name].geometry}
      material={nodes[name].material}
      material-emissive="black"
      material-roughness={1}
      {...props}
      dispose={null}
    />
  );
}
